import React from 'react';
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import dayjs from "dayjs";
import AboutYourBusinessView from './AboutYourBusinessView';
import bizTypes_i18n from '@app/messages/form-options-businessTypes.json';

import { CompileTOVS } from "@app/utils/CompileTOVS";
import { saveAs } from "file-saver";
import { Packer } from "docx";
import { DocumentCreator } from "@app/utils/DocumentCreator";

class ConnectedAboutYourBusinessContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            locale: this.props.locale ? this.props.locale : 'en',
            pageLoad: '',
            bizTypes: [],
            years: [],
            // Application Form
            // Stats
            howHearAboutVoucher: '',
            didAttendTOVWebinar: '',
            didAttendTOVDate: '',
            // Beneficiary Details
            personName: '',
            companyName: '',
            companyAddress: '',
            telephone: '',
            mobilePhone: '',
            emailAddress: '',
            webAddress: '',
            onlineOffline: '',
            businessType: '',
            croNumber: '',
            yearEstablished: '',
            currentOnlinePresence: '',
            validationErrors: {
                // Application Form
                // Stats
                howHearAboutVoucher: { show: false, check: null, errorMessage: ''  },
                didAttendTOVWebinar: { show: false, check: null, errorMessage: ''  },
                didAttendTOVDate: { show: false, check: null, errorMessage: ''  },
                // Beneficiary Details
                personName: { show: false, check: null, errorMessage: ''  },
                companyName: { show: false, check: null, errorMessage: ''  },
                companyAddress: { show: false, check: null, errorMessage: ''  },
                telephone: { show: false, check: null, errorMessage: ''  },
                mobilePhone: { show: false, check: null, errorMessage: ''  },
                emailAddress: { show: false, check: null, errorMessage: ''  },
                webAddress: { show: false, check: null, errorMessage: ''  },
                onlineOffline: { show: false, check: null, errorMessage: ''  },
                businessType: { show: false, check: null, errorMessage: ''  },
                croNumber: { show: false, check: null, errorMessage: ''  },
                yearEstablished: { show: false, check: null, errorMessage: ''  },
                currentOnlinePresence: { show: false, check: null, errorMessage: ''  }
            },
            isLoading: false,
            errorMessage: '',
            successMessage: '',
            loadToSubmitTime: '',
            shareMessage: ''
        };

        this.loadBizTypes = this.loadBizTypes.bind(this);
        this.loadYears = this.loadYears.bind(this);
        this.handleChange = this.handleChange.bind(this);
        // Application Form
        // Stats
        this.setHowHearAboutVoucher = this.setHowHearAboutVoucher.bind(this);
        this.handleHowHearAboutVoucher = this.handleHowHearAboutVoucher.bind(this);
        this.handleDidAttendTOVWebinar = this.handleDidAttendTOVWebinar.bind(this);
        this.handleDidAttendTOVDate = this.handleDidAttendTOVDate.bind(this);
        // Beneficiary Details
        this.handlePersonName = this.handlePersonName.bind(this);
        this.handleCompanyName = this.handleCompanyName.bind(this);
        this.handleCompanyAddress = this.handleCompanyAddress.bind(this);
        this.handleTelephone = this.handleTelephone.bind(this);
        this.handleMobilePhone = this.handleMobilePhone.bind(this);
        this.handleOnlineOffline = this.handleOnlineOffline.bind(this);
        this.handleBusinessType = this.handleBusinessType.bind(this);
        this.handleCroNumber = this.handleCroNumber.bind(this);
        this.handleYearEstablished = this.handleYearEstablished.bind(this);
        this.handleCurrentOnlinePresence = this.handleCurrentOnlinePresence.bind(this);
        this.onEmailChange = this.onEmailChange.bind(this);
        this.onWebsiteChange = this.onWebsiteChange.bind(this);
        this.generateDoc = this.generateDoc.bind(this);
    }

    componentDidMount() {
        if (this.state.pageLoad === '') {
            this.setState({
                pageLoad: new Date().valueOf()
            });
        }
        for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).startsWith('tovsForm.about.')) {
                this.setState({
                    [localStorage.key(i).substring(15)]: localStorage.getItem(localStorage.key(i))
                });
            }
        }
        this.loadBizTypes();
        this.loadYears();
    }

    loadBizTypes() {
        let bizTypes = [];
        bizTypes_i18n.formOptionsBusinessTypes.forEach(option => {
            const key = Object.keys(option)[0];
            bizTypes.push({ key: key, value: option[key][this.props.locale] });
        });
        this.setState({
            bizTypes: bizTypes
        });
    }

    loadYears() {
        let years = [];
        let currentYear = dayjs().year();
        for (var i = currentYear; i > 1920; i--) {
            years.push({key: i, value: i})
        }
        this.setState({
            years: years
        });
    }

    handleChange(e) {
        this.setState({ 
            [e.target.value]: e.target.checked
        });
    }

    // Application Form
    // Stats
    setHowHearAboutVoucher(value) {
        let validationErrors = this.state.validationErrors;
        validationErrors.howHearAboutVoucher.show = false;
        validationErrors.howHearAboutVoucher.errorMessage = '';
        validationErrors.howHearAboutVoucher.check = true;
        localStorage.setItem('tovsForm.about.howHearAboutVoucher', value.trim());      
        this.setState({ 
            howHearAboutVoucher: value,
            validationErrors: validationErrors
        });
    }

    handleHowHearAboutVoucher(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        if (value.length === 0) {
            validationErrors.howHearAboutVoucher.show = true;
            validationErrors.howHearAboutVoucher.errorMessage = 'You should say how you heard about this voucher scheme. Write LocalPro.ie if you have nothing else to write.';
            validationErrors.howHearAboutVoucher.check = false;
        }
        else {
            validationErrors.howHearAboutVoucher.show = false;
            validationErrors.howHearAboutVoucher.errorMessage = '';
            validationErrors.howHearAboutVoucher.check = true;
            localStorage.setItem('tovsForm.about.howHearAboutVoucher', value.trim());
        }
        this.setState({ 
            howHearAboutVoucher: value,
            validationErrors: validationErrors
        });
    }

    handleDidAttendTOVWebinar(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        if (value === 'yes') {
            validationErrors.didAttendTOVWebinar.check = true;
            validationErrors.didAttendTOVWebinar.errorMessage = '';
            validationErrors.didAttendTOVWebinar.show = false;
        }
        else {
            validationErrors.didAttendTOVWebinar.check = false;
            if (value === 'no') {
                validationErrors.didAttendTOVWebinar.errorMessage = 'You will need to attend a webinar before you can submit your application.';
                validationErrors.didAttendTOVWebinar.show = true;
            }
            else if (value === 'notSure') {
                validationErrors.didAttendTOVWebinar.errorMessage = 'If you are unsure if you attended a webinar it\'s likely that you did not, or it was too long ago.';
                validationErrors.didAttendTOVWebinar.show = true;
            }
        }
        this.setState({ 
            didAttendTOVWebinar: e.target.value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.about.didAttendTOVWebinar', value);
    }

    handleDidAttendTOVDate(e) {
        let validationErrors = this.state.validationErrors;
        let selectedDate = dayjs(e);
        if (selectedDate.isAfter(dayjs().subtract( 9, 'month' ))) {
            validationErrors.didAttendTOVDate.check = true;
            validationErrors.didAttendTOVDate.errorMessage = '';
            validationErrors.didAttendTOVDate.show = false;
            this.setState({ 
                didAttendTOVDate: selectedDate
            });
            localStorage.setItem('tovsForm.about.didAttendTOVDate', selectedDate);
        }
        else {
            validationErrors.didAttendTOVDate.check = false;
            validationErrors.didAttendTOVDate.errorMessage = "You will likely need to attend a more recent webinar than one from " + selectedDate.year() + ".";
            validationErrors.didAttendTOVDate.show = true;
            
        }
        this.setState({
            validationErrors: validationErrors
        });
    }

    // Beneficiary Details
    handlePersonName(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isPersonNameValid = value !== '' && value.trim().match(/^([A-Za-zÀ-ÖØ-öø-ÿ]{1,}([\.] |[-']| ))+[A-Za-zÀ-ÖØ-öø-ÿ]+\.?$/i) !== null;
        if (isPersonNameValid) {
            validationErrors.personName.check = true;
            validationErrors.personName.errorMessage = '';
            localStorage.setItem('tovsForm.about.personName', value);
        }
        else {
            validationErrors.personName.check = false;
            validationErrors.personName.errorMessage = 'Name is invalid, at least first and last name are required';
        }
        validationErrors.personName.show = !isPersonNameValid;
        this.setState({
            personName: value,
            validationErrors: validationErrors
        });
    }

    handleCompanyName(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isCompanyNameValid = value !== '';
        validationErrors.companyName.show = !isCompanyNameValid;
        if (isCompanyNameValid) {
            validationErrors.companyName.check = true;
            validationErrors.companyName.errorMessage = '';
            localStorage.setItem('tovsForm.about.companyName', value);
        }
        else {
            validationErrors.companyName.check = false;
            validationErrors.companyName.errorMessage = 'Company Name is empty. Write your first and last name if there is no company name. You might need to register one to apply.';
        }
        this.setState({
            companyName: value,
            validationErrors: validationErrors
        });
    }

    handleCompanyAddress(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isCompanyAddressValid = value !== '';
        validationErrors.companyAddress.show = !isCompanyAddressValid;
        if (isCompanyAddressValid) {
            validationErrors.companyAddress.check = true;
            validationErrors.companyAddress.errorMessage =  '';
            localStorage.setItem('tovsForm.about.companyAddress', value);
        }
        else {
            validationErrors.companyAddress.check = false;
            validationErrors.companyAddress.errorMessage = 'Company Address is empty. Enter the address where you receive your business post.';
        }
        this.setState({ 
            companyAddress: value,
            validationErrors: validationErrors
        });
    }

    handleTelephone(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isTelephoneValid = null;
        let isValueEmpty = value === '';
        if (!isValueEmpty) {
            isTelephoneValid = value.match(/^0[1-9]\s?[0-9]{0,1}\s?-?[0-9]{5,7}$/) !== null;
        }
        if (isValueEmpty || isTelephoneValid) {
            validationErrors.telephone.show = false;
            validationErrors.telephone.errorMessage = '';
            localStorage.setItem('tovsForm.about.telephone', value);
        }
        else {
            validationErrors.telephone.show = true;
            validationErrors.telephone.errorMessage = 'Phone number is invalid';
        }
        this.setState({
            telephone: value,
            validationErrors: validationErrors
        });
    }

    handleMobilePhone(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isMobilePhoneValid = null;
        let isValueEmpty = value === '';
        if (!isValueEmpty) {
            isMobilePhoneValid = value.match(/^08[356789]{1}\s?-?[0-9]{6,10}$/) !== null;
        }
        if (isValueEmpty || isMobilePhoneValid) {
            validationErrors.mobilePhone.show = false;
            validationErrors.mobilePhone.errorMessage = '';
            localStorage.setItem('tovsForm.about.mobilePhone', value);
        }
        else {
            validationErrors.mobilePhone.show = true;
            validationErrors.mobilePhone.errorMessage = 'Mobile phone number is invalid';
        }
        this.setState({
            mobilePhone: value,
            validationErrors: validationErrors
        });
    }

    handleOnlineOffline(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        if (value === 'online' || value === 'onlineOffline') {
            validationErrors.onlineOffline.check = true;
            validationErrors.onlineOffline.errorMessage = '';
            validationErrors.onlineOffline.show = false;
        }
        else if (value === 'notSure') {
            validationErrors.onlineOffline.errorMessage = 'If you are unsure if you have a website, you should ask someone you trust!';
            validationErrors.onlineOffline.show = true;
        }
        this.setState({ 
            onlineOffline: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.about.onlineOffline', value);
    }

    handleBusinessType(e) {
        let value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.businessType.check = true;
        this.setState({ 
            businessType: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.about.businessType', value);
    }

    handleCroNumber(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        let isCRONumberValid = value.trim().match(/^(([0-9]*))$/i) !== null;
        if (isCRONumberValid) {
            validationErrors.croNumber.check = true;
            localStorage.setItem('tovsForm.about.croNumber', value);
        }
        else {
            validationErrors.croNumber.check = false;
        }
        this.setState({ 
            croNumber: value,
            validationErrors: validationErrors
        });
    }

    handleYearEstablished(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.yearEstablished.check = true;
        this.setState({ 
            yearEstablished: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.about.yearEstablished', value);
    }

    handleCurrentOnlinePresence(e) {
        const value = e.target.value;
        let validationErrors = this.state.validationErrors;
        validationErrors.currentOnlinePresence.check = true;
        this.setState({ 
            currentOnlinePresence: value,
            validationErrors: validationErrors
        });
        localStorage.setItem('tovsForm.about.currentOnlinePresence', value);
    }

    onEmailChange(e, ref) {
        let value = ref && ref.newValue ? ref.newValue : e.target.value;
        let validationErrors = this.state.validationErrors;
        let isEmailAddressValid = value.trim().match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i) !== null;
        if (isEmailAddressValid) {
            validationErrors.emailAddress.errorMessage = '';
            validationErrors.emailAddress.check = true;
            localStorage.setItem('tovsForm.about.emailAddress', value);
        }
        else {
            validationErrors.emailAddress.errorMessage = this.props.intl.formatMessage({ id: "email.invalid" });
            validationErrors.emailAddress.check = false;
        }
        validationErrors.emailAddress.show = !isEmailAddressValid;
        this.setState({
            emailAddress: value.trim(),
            validationErrors: validationErrors
        });
    }

    onWebsiteChange(e, ref) {
        let value = ref && ref.newValue ? ref.newValue : e.target.value;
        let validationErrors = this.state.validationErrors;
        let isWebAddressValid = value.trim().match(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,18}(:[0-9]{1,5})?(\/.[^\s]+)*$/i) !== null;
        if (isWebAddressValid) {
            validationErrors.webAddress.errorMessage = '';
            validationErrors.webAddress.check = true;
            localStorage.setItem('tovsForm.about.webAddress', value);
        }
        else {
            validationErrors.webAddress.errorMessage = this.props.intl.formatMessage({ id: "web.invalid" });
            validationErrors.webAddress.check = false;
        }
        validationErrors.webAddress.show = !isWebAddressValid;
        this.setState({
            webAddress: value.trim(),
            validationErrors: validationErrors
        });
    }

    generateDoc() {
        const data = new CompileTOVS().compile(); 
        var documentCreator = new DocumentCreator();
        var doc = documentCreator.create(data);

        Packer.toBlob(doc).then(function (blob) {
            saveAs(blob, "TradingOnlineVoucherScheme-" + Date.now() + ".docx");
        });
    }

    generateViewProps() {
        return {
            ...this.state,
            handleChange: this.handleChange,
            // Application Form
            // Stats
            setHowHearAboutVoucher: this.setHowHearAboutVoucher,
            handleHowHearAboutVoucher: this.handleHowHearAboutVoucher,
            handleDidAttendTOVWebinar: this.handleDidAttendTOVWebinar,
            handleDidAttendTOVDate: this.handleDidAttendTOVDate,
            // Beneficiary Details
            handlePersonName: this.handlePersonName,
            handleCompanyName: this.handleCompanyName,
            handleCompanyAddress: this.handleCompanyAddress,
            handleTelephone: this.handleTelephone,
            handleMobilePhone: this.handleMobilePhone,
            handleOnlineOffline: this.handleOnlineOffline,
            handleBusinessType: this.handleBusinessType,
            handleCroNumber: this.handleCroNumber,
            handleYearEstablished: this.handleYearEstablished,
            handleCurrentOnlinePresence: this.handleCurrentOnlinePresence,

            onEmailChange: this.onEmailChange,
            onWebsiteChange: this.onWebsiteChange,
            generateDoc: this.generateDoc
        };
    }

    render() {
        const viewProps = this.generateViewProps();
        return (
            <AboutYourBusinessView {...viewProps} />
        );
    }
}

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLocale: locale => dispatch(setLocale(locale))
    };
};

const AboutYourBusinessContainer = injectIntl(connect(mapStateToProps,mapDispatchToProps)(ConnectedAboutYourBusinessContainer));

export default AboutYourBusinessContainer;